import { motion } from 'framer-motion';

// Componente reutilizável de título de seção

const PricingHeader = () => {
  return (
    <div className="text-center mb-5 position-relative">
      {/* Badge flutuante */}
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.8 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4"
        style={{
          background: 'linear-gradient(135deg, rgba(37, 211, 102, 0.1), rgba(6, 182, 212, 0.1))',
          border: '1px solid #F62690',
          color: '#7A00CC',
          fontSize: '0.875rem',
          fontWeight: 500,
        }}
      >
        <motion.span
          animate={{ rotate: [0, 15, -15, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          ✨
        </motion.span>
        Planos flexíveis e sem burocracia
      </motion.div>

      {/* Título principal */}
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="display-4 fw-bold mb-3"
        style={{
          background: 'linear-gradient(135deg, #0f172a 0%, #334155 50%, #0f172a 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-0.02em',
          lineHeight: 1.2,
        }}
      >
        Planos ideais{' '}
        <motion.span
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            duration: 0.5, 
            delay: 0.4,
            type: 'spring',
            stiffness: 200 
          }}
          style={{
            background: 'linear-gradient(135deg, #F62690, #7A00CC)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            position: 'relative',
          }}
        >
          pra você
          <motion.svg
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            style={{
              position: 'absolute',
              bottom: '-5px',
              left: 0,
              width: '100%',
              height: '10px',
            }}
            viewBox="0 0 200 10"
            fill="none"
          >
            <motion.path
              d="M0 5 Q 50 10, 100 5 T 200 5"
              stroke="url(#gradient)"
              strokeWidth="3"
              strokeLinecap="round"
              fill="none"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#F62690" />
                <stop offset="100%" stopColor="#7A00CC" />
              </linearGradient>
            </defs>
          </motion.svg>
        </motion.span>
      </motion.h1>

      {/* Subtítulo */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="lead mb-0"
        style={{
          color: '#64748b',
          fontSize: '1.125rem',
          maxWidth: '600px',
          margin: '0 auto',
          lineHeight: 1.7,
        }}
      >
        Faça parte da{' '}
        <motion.strong
          whileHover={{ scale: 1.1 }}
          style={{
            color: '#7A00CC',
            fontWeight: 700,
            cursor: 'default',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
          }}
        >
          <motion.span
            animate={{ rotate: 360 }}
            transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
          >
            ⚡
          </motion.span>
          #GIGA
        </motion.strong>
        , escolha o plano perfeito para você e comece a{' '}
        <span style={{ 
          color: '#0f172a', 
          fontWeight: 600,
          textDecoration: 'underline',
          textDecorationColor: '#7A00CC',
          textDecorationThickness: '3px',
          textUnderlineOffset: '3px',
        }}>
          transformar
        </span>{' '}
        seu atendimento hoje.
      </motion.p>

      {/* Elementos decorativos */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="position-absolute"
        style={{
          top: '50%',
          left: '10%',
          transform: 'translateY(-50%)',
          fontSize: '8rem',
          color: '#F62690',
          fontWeight: 900,
          zIndex: -1,
          userSelect: 'none',
        }}
      >
        #
      </motion.div>
    </div>
  );
};
export default PricingHeader;